// src/pages/Dashboard/Finance/Payroll/Index.jsx
import React, { useState } from "react";
import {
  Box,
  Grid,
  Alert,
  CircularProgress,
  Button,
  Typography,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TotalProfit from "./TotalProfit/TotalProfit";
import TotalExpenses from "./TotalExpenses/TotalExpenses";
import PharmacyReport from "./PharmacyReport/PharmacyReport";
import useFetchObjects from "../../../../api/useFetchObjects";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../context";
import "./DatePickerStyles.css";

const Index = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const token = auth?.user?.token;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Build query parameters based on date range
  const buildQueryParams = () => {
    const params = new URLSearchParams();
    if (startDate)
      params.append("start_date", startDate.toISOString().split("T")[0]);
    if (endDate) params.append("end_date", endDate.toISOString().split("T")[0]);
    return params.toString();
  };

  const [fetchParams, setFetchParams] = useState(
    "financial-reports"
  );

  const handleFilter = () => {
    const queryString = buildQueryParams();
    const newParams = queryString
      ? `financial-reports?${queryString}`
      : "financial-reports";
    setFetchParams(newParams);
  };

  // fetch ht procedure payments - commented out as endpoint doesn't exist
  // const { data: payments } = useFetchObjects(
  //   ["ht-payment"],
  //   `ht-payments`,
  //   token
  // );

  // ========================================================

  const { data, isLoading, isError, error } = useFetchObjects(
    ["financial-reports", fetchParams],
    fetchParams,
    token
  );

  return (
    <Box sx={{ width: "100%", padding: "20px" }}>
      {/* Header and Filter Controls */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
          {t("finance.financeReport")}
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText={t("finance.startDate")}
            className="date-picker-input"
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText={t("finance.endDate")}
            className="date-picker-input"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ height: "fit-content" }}
          >
            {t("finance.applyFilter")}
          </Button>
        </Box>
      </Box>

      {/* Loading, Error, and Report Data */}
      {isLoading ? (
        <CircularProgress />
      ) : isError ? (
        <Alert severity="error">{error.message}</Alert>
      ) : (
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} md={6}>
            <TotalProfit summaryData={data.summary || {}} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TotalExpenses
              payrollAndExpensesData={data.payroll_and_expenses || {}}
            />
          </Grid>
          <Grid item xs={12}>
            <PharmacyReport
              medicineSalesData={data.medicine_sales || {}}
              prescriptionData={data.prescription || {}}
              purchaseData={data.purchase || {}}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Index;
